import { LANGUAGES } from '@/utils/constants'

const { PORTUGUESE, ENGLISH, SPANISH } = LANGUAGES

export const NONE = 'none'
export const SCREENED = 'Screened'
export const ANSWERS = 'ANSWERS_'
export const SUBQUESTIONS = 'SUBQUESTIONS_'
export const AS = 'AS__'
export const FAIL_FLOW = 'FAIL__'
export const TARGET = 'TARGET__'
export const SELECTED = 'SELECTED__'
export const UNSELECTED = 'UNSELECTED__'
export const AND = 'ANND__'

export default {
  [PORTUGUESE]: {
    [NONE]: 'Nenhum',
    [SCREENED]: 'Screened',
    [ANSWERS]: 'Respostas',
    [SUBQUESTIONS]: 'Sub Respostas',
    [AS]: 'Como',
    [FAIL_FLOW]: 'Ação caso não encontre respostas',
    [TARGET]: 'Origem',
    [SELECTED]: 'Selecionadas',
    [UNSELECTED]: 'Não Selecionadas',
    [AND]: 'E',
  },

  [ENGLISH]: {
    [NONE]: 'None',
    [SCREENED]: 'Screened',
    [ANSWERS]: 'Answers',
    [SUBQUESTIONS]: 'SubQuestions',
    [AS]: 'As',
    [FAIL_FLOW]: 'Action if no options found',
    [TARGET]: 'Target',
    [SELECTED]: 'Selected',
    [UNSELECTED]: 'Unselected',
    [AND]: 'and',
  },

  [SPANISH]: {
    [NONE]: 'Ninguno',
    [SCREENED]: 'Screened',
    [ANSWERS]: 'Respuestas',
    [SUBQUESTIONS]: 'Sub Respuestas',
    [AS]: 'Como',
    [FAIL_FLOW]: 'Action if no options found',
    [TARGET]: 'Origem',
    [SELECTED]: 'Selecionadas',
    [UNSELECTED]: 'Não Selecionadas',
    [AND]: 'E',
  },
}
